module.exports = __webpack_public_path__ + "img/pictoPeople5.b97021db.svg";